import { render, staticRenderFns } from "./ProductDownstreamEmissionByPartner.vue?vue&type=template&id=53df7a96"
import script from "./ProductDownstreamEmissionByPartner.vue?vue&type=script&lang=js"
export * from "./ProductDownstreamEmissionByPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports